import { Typography, type TypographyProps, Stack, Box, type BoxProps } from '@mui/material'
import { SectionItem, type SectionItemProps } from 'settle-ui/components/SectionItem/SectionItem'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'
import type { WithoutSystemProps } from 'types'

interface SectionProps extends WithoutSystemProps<BoxProps> {
  title?: string
  subtitle?: TypographyProps['children']
  slots?: {
    rightSide?: React.ReactNode
  }
  slotProps?: {
    header?: SectionItemProps
  }
  fullWidth?: boolean
}

export const Section: Settle.FC<SectionProps> = ({
  title,
  subtitle,
  slots,
  slotProps,
  children,
  sx,
  fullWidth,
  ...props
}) => (
  <Box {...props} sx={mergeSx({ py: 1, width: fullWidth ? '100%' : 'auto' }, sx)}>
    {Boolean(title || subtitle || slots?.rightSide) && (
      <SectionItem fullWidth={fullWidth} verticalGutter="none" {...slotProps?.header}>
        {(title || slots?.rightSide) && (
          <Stack
            direction="row"
            sx={{ justifyContent: title ? 'space-between' : 'flex-end', alignItems: 'center', pb: 1 }}
          >
            {title && <Typography variant="subtitle1">{title}</Typography>}
            {slots?.rightSide}
          </Stack>
        )}
        {subtitle && (
          <Typography variant="body2" color="onSurfaceSecondary" sx={{ pb: 1 }}>
            {subtitle}
          </Typography>
        )}
      </SectionItem>
    )}
    <Box>{children}</Box>
  </Box>
)
